export default {"src":"/_next/static/media/log-out.33d4352f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};